import React from 'react';

/** Color tones for the Badge, mirroring the app's soft pastel pill palette. */
export type BadgeTone = 'slate' | 'amber' | 'blue' | 'green' | 'purple' | 'violet' | 'indigo' | 'sky' | 'orange';

const TONE_CLASSES: Record<BadgeTone, string> = {
  slate: 'bg-slate-100 text-slate-600',
  amber: 'bg-amber-100 text-amber-800',
  blue: 'bg-primary-100 text-primary-700',
  green: 'bg-green-100 text-green-700',
  purple: 'bg-purple-100 text-purple-700',
  violet: 'bg-purple-100 text-purple-700',
  indigo: 'bg-primary-100 text-primary-700',
  sky: 'bg-sky-100 text-sky-700',
  orange: 'bg-amber-100 text-amber-700',
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Visual tone; defaults to slate */
  tone?: BadgeTone;
}

/**
 * Reusable pill badge for inline labels and stamps.
 * Used for declarative module tags (e.g. "Beta") and other small status pills.
 */
const Badge: React.FC<BadgeProps> = ({ tone = 'slate', className = '', children, ...props }) => (
  <span
    className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${TONE_CLASSES[tone]} ${className}`}
    {...props}
  >
    {children}
  </span>
);

export default Badge;
